export  function loadCredential(credential) {
  localStorage.setItem('ACCESS_TOKEN_SENZAGRO', credential.access_token);
  localStorage.setItem('ACCOUNT', credential.references[0]);
  localStorage.setItem('REFRESH_TOKEN', credential.refresh_token);
  localStorage.setItem('ROLE', credential.role);
  localStorage.setItem('USER_ID', credential.id);
  localStorage.setItem('NAME', credential.name);
};

export  function getRefreshToken() {
  return localStorage.getItem('REFRESH_TOKEN');
}

export  function getAccount() {
  return localStorage.getItem('ACCOUNT');
}

export  function setUsername(username) {
  localStorage.setItem('USERNAME', username);
}

export  function getUsername() {
  return localStorage.getItem('USERNAME');
}

export  function getName() {
  return localStorage.getItem('NAME');
}

export  function getUserId() {
  return localStorage.getItem('USER_ID');
}

export  function getRole() {
  return +localStorage.getItem('ROLE');
}

export  function getAccessToken() {
  return localStorage.getItem('ACCESS_TOKEN_SENZAGRO');
}

export  function hasSmartFarmPermission() {
  return true;
}

export  function hasSettingsPermission() {
  return isSuper() || getRole()!==3000;
}

export  function hasCashFlowPermission() {
  return isSuper() || getRole()!==3000;
}

export  function hasDailyUpdatePermission() {
  return isSuper() || getRole()!==3000;
}

export function isSuper() {
  return localStorage.getItem('ROLE') <= 5;
}

export  function hasWritePermission() {
  return getRole()!==2000;
}

export  function signOut() {
  localStorage.clear();
}
